import apiFetch from '../apiFetch'

export default function (entityId, body, token) {
  return apiFetch({ endPoint: 'entity/' + entityId, method: 'PUT', body: body, token: token })
}
